import type { MultilineTextInputProps } from '@_/ui';
import type { FormComponentProps } from './types.ts';
import { MultilineTextInput } from '@_/ui';
import { useFieldContext } from './BaseForm.ts';
import { usePropsFromField } from './utils.ts';

export function FormMultilineTextInput(
  props: FormComponentProps<Omit<MultilineTextInputProps, 'onChange' | 'value'>>
) {
  const field = useFieldContext<string>();

  return (
    <MultilineTextInput
      key={field.name}
      {...usePropsFromField(props, field)}
      onBlur={field.handleBlur}
      onChange={e => field.handleChange(e.target.value)}
      value={field.state.value}
    />
  );
}
